<template>
  <table class="table table-sm table-responsive-md table-striped">
    <thead>
    <tr>
      <th></th>
      <th></th>
      <th>{{$t('views.exsborder.list.idCase')}}</th>
      <th>{{$t('views.application.form.idUserData')}}</th>
      <th class="text-center">{{ $t('views.excmtask.list.progress') }}</th>
      <th v-if="displayAssigned">{{$t('modals.finishedTaskDocument.idDoneByUserData')}}</th>
      <th>{{$t('views.dashboard.dispatcher.assigned.type')}}</th>
      <th>{{$t('views.dashboard.dispatcher.assigned.task')}}</th>
      <th></th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="(item, itemIndex) in items" :key="'task_'+itemIndex">
      <td class="text-center">
        <b-form-checkbox
          v-if="ableToTakeTask(item)"
          v-model="$store.state.checkboxes.selectedTasks"
          :value="getIdLink(item['@id'])"
        ></b-form-checkbox>
      </td>
      <td>
        <i v-if="item.lastPoolTask && !item.lastPoolTask.operationTransferUserData"  class="fa fa-circle fa-lg" style="color: #dc3545" v-b-tooltip.hover :title="$t('global.notAssigned')"></i>
        <i v-else class="fa fa-circle fa-lg" style="color: #28a745" v-b-tooltip.hover :title="$t('global.assigned')"></i>
      </td>
      <td>
        <router-link
          v-if="ableToShowCase"
          :to="{name: 'EXCMCaseShow', params: { id: item.idCase['@id'] }}">
          <span v-if="item.idCase.number">{{item.idCase.number}}</span>
          <span v-else>{{getIdLink(item.idCase['@id'])}}</span>
        </router-link>
        <span v-else>
          <span v-if="item.idCase.number">{{item.idCase.number}}</span>
          <span v-else>{{getIdLink(item.idCase['@id'])}}</span>
        </span>
      </td>
      <td>
        <div v-if="item.idCase.contractorUserData">
          <router-link
            v-if="ableToShowFirm"
            :to="{name: 'FirmShow', params: { id: item.idCase.contractorUserData['@id'] }}">
            {{ item.idCase.contractorUserData.firmname1 || item.idCase.contractorUserData.fullName }}
          </router-link>
          <div v-else>
            {{item.idCase.contractorUserData.firmname1 || item.idCase.contractorUserData.fullName }}
          </div>
          <span v-if="item.idCase.contractorUserData.city">
              {{ ' - ' + item.idCase.contractorUserData.city }}
          </span>
          <span v-if="item.idCase.contractorUserData.street">
             {{ ', ' + item.idCase.contractorUserData.street }}
          </span>
          <span v-if="item.idCase.contractorUserData.streetNumber">
             {{ item.idCase.contractorUserData.streetNumber }}
          </span>
          <span v-if="item.idCase.contractorUserData.placeNumber">
             {{ ' / ' + item.idCase.contractorUserData.placeNumber }}
          </span>
        </div>
        <div v-if="item.idCase.partnerUserData">
          <span>{{$t('views.excmcase.form.partnerUserData')}}: </span>
          <span v-if="item.idCase.partnerUserData.firmname1">
            {{ item.idCase.partnerUserData.firmname1 }}
          </span>
          <span v-else-if="item.idCase.partnerUserData.fullName">
            {{ item.idCase.partnerUserData.fullName }}
          </span>
          <div v-if="item.idCase.partnerUserData.userEmail">
            <a :href="'mailto:' + item.idCase.partnerUserData.userEmail">
              {{ item.idCase.partnerUserData.userEmail }}
            </a>
          </div>
          <div v-if="item.idCase.partnerUserData.contactEmail">
            <a :href="'mailto:' + item.idCase.partnerUserData.contactEmail">
              {{ item.idCase.partnerUserData.contactEmail }}
            </a>
          </div>
        </div>
      </td>
      <td class="text-center">
        <div v-if="item.state === 0">
          <b-badge>
            {{ $t('views.excmagreements.list.filters.state') }}
          </b-badge>
        </div>
        <div v-else-if="item.finished === 0">
          <b-badge v-if="item.started === 0" variant="danger">
            {{ $t('views.excmtask.show.dailyPlanItemStatuses.notOver') }}
          </b-badge>
          <b-badge v-else-if="item.started === 1" variant="warning">
            {{ $t('views.excmtask.show.inProgress') }}
          </b-badge>
          <div v-if="item.deadlineDate">
            <b-badge :variant="getProgress(item) > 100 ? 'danger' : null">
              {{ getProgress(item) > 100 ? $t('views.excmtask.list.deadlineExceeded') : getProgress(item) + ' %' }}
            </b-badge>
          </div>
          <deadline-date-info :item="item"/>
          <div v-if="item.deadlineDate">
            <small class="d-block">
              {{ $moment(item.createdAt).format('YYYY-MM-DD HH:mm') }}
            </small>
            <small class="d-block">
              {{' - ' + $moment(item.deadlineDate).format('YYYY-MM-DD HH:mm')}}
            </small>
            <Progress
              v-if="getProgress(item) < 100"
              :type="'primary'"
              :value="getProgress(item)">
            </Progress>
          </div>
        </div>
        <div v-else-if="item.finished === 1">
          <b-badge variant="success">
            {{ $t('views.excmtask.show.dailyPlanItemStatuses.finished') }}
          </b-badge>
        </div>
      </td>
      <td v-if="displayAssigned">
        <div v-if="item.lastPoolTask && item.lastPoolTask.operationTransferUserData">
          {{ item.lastPoolTask.operationTransferUserData.name + ' ' + item.lastPoolTask.operationTransferUserData.surname }}
        </div>
      </td>
      <td>
        <router-link
          v-if="ableToShowCase"
          :to="{name: 'EXCMCaseShow', params: { id: item.idCase['@id'] }}">
          {{ item.idCase.caseType.title }}
        </router-link>
        <span v-else>
          {{ item.idCase.caseType.title }}
        </span>
      </td>
      <td>
        <router-link
          class="d-inline-block"
          v-if="ableToShowTask && item.canViewDetails"
          :to="{name: 'EXCMTaskShow', params: { id: item['@id'] }}">
          {{ item.idTaskType.title }}
        </router-link>
        <span v-else>
            {{ item.idTaskType.title }}
        </span>
        <div v-for="(customField, index) in item.customFields" v-bind:key="index" v-show="item.canViewDetails && !isRoleForCustomFieldDisabled(item)">
          <p class="m-0" v-if="customField.label && customField.type === 'datetime'">{{customField.label}}: <span v-if="customField.value">{{$moment(customField.value).format('YYYY-MM-DD')}}</span><span v-else>{{$t('null')}}</span></p>
          <p class="m-0" v-else-if="customField.name && customField.type === 'datetime'">{{customField.name}}: <span v-if="customField.value">{{$moment(customField.value).format('YYYY-MM-DD')}}</span><span v-else>{{$t('null')}}</span></p>
          <p class="m-0" v-else-if="customField.type === 'multiSelect'">{{customField.label}}: <span v-if="customField.value.length > 0">{{customField.value.join(', ')}}</span><span v-else>{{$t('null')}}</span> </p>
          <p class="m-0" v-else-if="customField.label && customField.value">{{customField.label}}: {{(customField.value)}}</p>
          <p class="m-0" v-else-if="customField.name && customField.value">{{customField.name}}: {{(customField.value)}}</p>
        </div>
      </td>
      <td>
        <b-dropdown v-if="ableToManageThisTask(item)" size="sm" variant="link" right text="Right align" toggle-class="text-decoration-none" no-caret>
          <template #button-content>
            <i class="fa fa-bars fa-lg"></i>
          </template>
          <b-dropdown-item v-if="ableToReturnTask(item)" @click="taskOperation(item, 'return')">
            <i class="fas fa-undo-alt fa-lg"></i>
            {{ $t('buttons.returnTask') }}
          </b-dropdown-item>
          <b-dropdown-item v-if="ableToAddTaskToMyCalendar(item)" @click="addTaskToMyCalendar(item['@id'])">
            <i class="fas fa-calendar fa-lg"></i>
            {{ $t('buttons.addToMyCalendar') }}
          </b-dropdown-item>
          <b-dropdown-item v-if="ableToTakeTask(item)" @click="taskOperation(item, 'take')">
            <i class="fas fa-undo-alt fa-lg"></i>
            {{ $t('buttons.takeTask') }}
          </b-dropdown-item>
          <b-dropdown-item v-if="ableToTakeTask(item)" @click="taskOperation(item, 'take', true)">
            <i class="fas fa-undo-alt fa-lg"></i>
            {{ $t('buttons.takeTaskAndGoTo') }}
          </b-dropdown-item>
          <b-dropdown-item
            v-if="item.finished === 0 && ableToDispatchTask && item.lastPoolTask && !item.lastPoolTask.operationTransferUserData  && item.canUpdate"
            aria-label="Dispatch task"
            @click="dispatchTask(item['@id'])"
          >
            <i class="fa fa-check-square fa-lg"></i>
            {{ $t('buttons.dispatchTask') }}
          </b-dropdown-item>
          <b-dropdown-item
            v-if="ableToViewDailyPlan && item.lastPoolTask && item.lastPoolTask.operationTransferUserData"
            @click="goToDailyPlan(item)">
            <i class="fa fa-calendar-day fa-lg"></i>
            {{ $t('buttons.showDailyPlan') }}
          </b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item v-if="item.canViewDetails" @click="goToTask(item['@id'])">
            <i class="fa fa-search fa-lg"></i>
            {{ $t('buttons.show') }}
          </b-dropdown-item>
          <b-dropdown-item v-if="item.canUpdate && ableToCreateTask && getIdLink(item.idCase.status['@id']) === '1'" @click="addTask(item.idCase['@id'])">
            <i class="fa fa-plus-circle fa-lg"></i>
            {{ $t('buttons.addTask') }}
          </b-dropdown-item>
          <b-dropdown-item v-if="item.canUpdate && ableToUpdateTask && item.finished === 0" @click="editTaskParams(item['@id'])">
            <i class="fa fa-edit fa-lg"></i>
            {{ $t('buttons.editTaskParams') }}
          </b-dropdown-item>
        </b-dropdown>
      </td>
    </tr>
    </tbody>
  </table>
</template>
<script>
import Progress from '@/components/UIComponents/Progress'
import { checkPermission, getUserRoles } from '@/utils/checkRoles'
import getId from '@/utils/getIdFromLink'
import ApiService from '@/utils/ApiService'
import DeadlineDateInfo from '@/components/Dashboard/Views/excmtask/components/deadlineDateInfo.vue'

export default {
  name: 'TasksTable',
  components: { DeadlineDateInfo, Progress },
  props: {
    items: {},
    displayAssigned: {},
    toggleCreateTaskModal: {},
    getData: {}
  },
  computed: {
    ableToShowFirm () {
      return checkPermission('firms', 'FirmShow')
    },
    ableToShowTask () {
      return checkPermission('tasks', 'EXCMTaskShow')
    },
    ableToDispatchTask () {
      return checkPermission('tasks', 'EXCMTaskShow', 'dispatchTask')
    },
    ableToShowCase () {
      return checkPermission('cases', 'EXCMCaseShow') && this.displayAssigned
    },
    ableToViewDailyPlan () {
      return checkPermission('serviceman', 'DailyPlanShow')
    },
    ableToCreateTask () {
      return checkPermission('tasks', 'EXCMTaskCreate')
    },
    ableToUpdateTask () {
      return checkPermission('tasks', 'EXCMTaskUpdate') && this.displayAssigned
    },
    isWholesaler () {
      return getUserRoles().roles.includes('ROLE_WHOLESALER')
    },
    isControlling () {
      return getUserRoles().roles.includes('ROLE_CONTROLLING')
    },
    isSuperUser () {
      return getUserRoles().roles.includes('ROLE_SUPER_USER') || getUserRoles().roles.includes('ROLE_OWNER')
    },
    getUserId () {
      return getUserRoles().id_userdata
    }
  },

  methods: {
    getProgress (task) {
      if (!task.deadlineDate) {
        return 100
      } else {
        let created = this.$moment(task.createdAt)
        let deadline = this.$moment(task.deadlineDate)
        return this.calculateProgress(created, deadline)
      }
    },
    calculateProgress (created, deadline) {
      let denominator, nominator
      denominator = deadline.diff(created)
      nominator = this.$moment().diff(created)
      return Math.round((nominator / denominator) * 100)
    },
    getId (link) {
      return getId(link)
    },
    goToDailyPlan (item) {
      if (!item.lastPoolTask) return
      let idServiceman = getId(item.lastPoolTask.operationTransferUserData['@id'])
      let date = this.$moment(item.lastPoolTask.operationDate).format('YYYY-MM-DD')
      this.$router.push({ name: 'DailyPlanShow', params: { idServiceman: idServiceman, date: date } })
    },
    goToTask (id) {
      if (this.ableToShowTask) this.$router.push({ name: 'EXCMTaskShow', params: { id: id } })
    },
    editTaskParams (id) {
      this.$store.state.modals.updateTaskParams.show = 1
      this.$store.state.modals.updateTaskParams.path = id
    },
    addTask (idCase) {
      this.selectedCase = idCase
      this.$emit('selectedCase', idCase)
      this.toggleCreateTaskModal()
    },
    dispatchTask (iri) {
      this.$store.state.modals.excmtask.dispatch.show = 1
      this.$store.state.modals.excmtask.dispatch.taskIRI = iri
    },
    addTaskToMyCalendar (taskIRI) {
      this.$store.state.modals.excmtask.addToMyCalendar.show = 1
      this.$store.state.modals.excmtask.addToMyCalendar.taskIRI = taskIRI
    },
    getIdLink (link) {
      return getId(link)
    },
    ableToManageThisTask (task) {
      if (this.isSuperUser || this.isControlling) return true
      if (task.idCase.currentOwnerUserData && getId(task.idCase.currentOwnerUserData['@id']) === this.getUserId) {
        return true
      }
      if (!task.lastPoolTask.operationTransferUserData) {
        return true
      }
      return false
    },
    ableToReturnTask (task) {
      if (this.isWholesaler) return false
      if (!task) return false
      if (!task.canUpdate) return false
      return task.lastPoolTask ? !!(!this.isFinished(task) && [1, 2, 3].includes(task.lastPoolTask.operation)) : false
    },
    ableToAddTaskToMyCalendar (task) {
      if (!this.ableToReturnTask(task)) return false
      if (task.lastPoolTask.operationTransferUserData && getId(task.lastPoolTask.operationTransferUserData['@id']) !== this.getUserId) return false
      if (task.lastDailyPlanItem) return false
      return true
    },
    ableToTakeTask (task) {
      if (this.isWholesaler) return false
      if (!task) return false
      if (!task.canTake) {
        return false
      }
      if (!task.canUpdate) return false
      return task.lastPoolTask ? !!(!this.isFinished(task) && task.lastPoolTask.operation === 0) : false
    },
    isFinished (task) {
      return task.finished === 1
    },
    async taskOperation (task, operation, goToTaskAfter = false) {
      const decision = await this.$Swal({
        title: operation === 'return' ? this.$t('notifications.excmtask.taskReturn') : this.$t('notifications.excmtask.takeTask'),
        type: 'question',
        showConfirmButton: true,
        confirmButtonText: this.$t('buttons.yes'),
        showCancelButton: true,
        cancelButtonText: this.$t('buttons.no')
      })
      if (decision) {
        const response = await new ApiService(`e_x_c_m_tasks/${getId(task.id)}/${operation}`).put({})
        if (response.status === 200) {
          if (goToTaskAfter) {
            this.$router.push({ name: 'EXCMTaskShow', params: { id: task['@id'] } })
          } else {
            this.getData()
          }
        }
      }
    },
    isRoleForCustomFieldDisabled (customField) {
      if (customField.disabledRoles && customField.disabledRoles.length > 0) {
        let idClientType = getUserRoles().id_client_type
        if (customField.disabledRoles.includes(idClientType)) {
          return true
        }
      }
      return false
    }
  }
}
</script>
